import novelaTheme from '@narative/gatsby-theme-novela/src/gatsby-plugin-theme-ui';

export default {
  ...novelaTheme,
  colors: {
    ...novelaTheme.colors,
    primary: '#282828',
    secondary: '#73737D',
    grey: '#73737D',
    background: '#eae7d4',
    accent: '#6166DC',
    hover: 'rgba(0, 0, 0, 0.07)',
    gradient:
      'linear-gradient(180deg, rgba(217, 219, 224, 0) 0%, #D9DBE0 100%)',
    articleText: '#08080B',
    track: 'rgba(8, 8, 11, 0.3)',
    progress: '#282828',
    card: '#e2dcc7',
    error: '#EE565B',
    success: '#46B17B',
    errorBackground: 'rgba(238, 86, 91, 0.1)',
    horizontalRule: 'rgba(8, 8, 11, 0.15)',
    inputBackground: 'rgba(0, 0, 0, 0.05)',
    modes: {
      dark: {
        grey: '#a09c92',
        primary: '#eae7d4',
        secondary: '#fff',
        accent: '#E9DAAC',
        background: '#282828',
        hover: 'rgba(255, 255, 255, 0.07)',
        gradient: 'none',
        articleText: '#fff',
        track: 'rgba(255, 255, 255, 0.3)',
        progress: '#eae7d4',
        card: '#1D2021',
        error: '#EE565B',
        success: '#46B17B',
        errorBackground: 'rgba(238, 86, 91, 0.1)',
        horizontalRule: 'rgba(255, 255, 255, 0.15)',
        inputBackground: 'rgba(255, 255, 255, 0.07)',
      },
    },
  },
  // fonts: {
  //   ...novelaTheme.fonts,
  //   serif: "'Roboto', serif",
  // },
};
